import { render } from "./StatisticView.vue?vue&type=template&id=66c6b33a"
import script from "./StatisticView.vue?vue&type=script&lang=js"
export * from "./StatisticView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__